import ".././styles/FeaturedEvents.css";
import { HashLink as Link } from 'react-router-hash-link';
function FeaturedEvents() {
    // <script>
    //     GET https://www.googleapis.com/blogger/v3/blogs/4206628408241570047?key=AIzaSyDZP2fJat5Pt6yANzy9xrgb5wAxFYyYkVk
         
    // </script>
    // fetch("https://www.googleapis.com/blogger/v3/blogs/4206628408241570047?key=AIzaSyDZP2fJat5Pt6yANzy9xrgb5wAxFYyYkVk");
    // async function getData() {
    //     const url = "https://www.googleapis.com/blogger/v3/blogs/4206628408241570047/posts?key=AIzaSyDZP2fJat5Pt6yANzy9xrgb5wAxFYyYkVk";
    //     try {
    //       const response = await fetch(url);
    //       if (!response.ok) {
    //         throw new Error(`Response status: ${response.status}`);
    //       }
      
    //       const json = await response.json();
    //       console.log(json.items[1]);
    //     } catch (error) {
    //       console.error(error.message);
    //     }
    //   }
    //   getData();

    // const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false },)
    // useEffect(() => {
    //     if (emblaApi) {
    //         console.log(emblaApi.slideNodes()) // Access API
    //     }
    // }, [emblaApi])
    return (
        
        <div className="container section">
            <h2 className="section-title">
                Upcoming Events
            </h2>
            <div className="featured-events">
                <div className="calendar">
                    <div data-tockify-component="mini" data-tockify-calendar="thepccm" data-tockify-view="agenda"
                    data-tockify-width="100%" data-tockify-height="100%"></div> {/** The script is in index.html */}
                </div>
                <Link to="/events#events" className="news-view-more button-1">
                    View More
                </Link>
            </div>
        </div>
    );
}

export default FeaturedEvents;